import * as React from "react";
import {cs} from "../../../../../../../../react/chain-services";
import {consumeContext} from "../../../../../../../../react/context";
import "./select-target-section.scss";
import {SelectTargetForms} from "./select-target-forms/select-target-forms";
import {cx} from "emotion";
import {Radio} from "../../../../../../common/design2/radio/radio";
import {UseState} from "../../../../../../../../react/use-state";

export const SelectTargetSection = ({next}) => cs(
    consumeContext("company"),
    ["type", (_, next) => UseState({
        initValue: "zip",
        next,
    })],
    ["forms", ({}, next) => SelectTargetForms({next})],
    ["selectTargetForm", ({forms, type}, next) => next(type.value && forms.getForm(type.value))],
    ({company, selectTargetForm, type}) => next({
        valid: selectTargetForm?.valid,
        highlightErrors: selectTargetForm?.highlightErrors,
        getSearchRequest: () => ({
            mode: type.value,
            ...selectTargetForm?.getSearchRequest(),
        }),
        handleApiError: selectTargetForm?.handleApiError,
        render: ({showErrors}) => (
            <div className="select-target-section-6y6">
                <div className="header">
                    <div className="title" xd-qa-type="label" xd-qa-name="Neighborhood Search Define Target Area">
                        Define Target Area
                    </div>
                    
                    <div className="sub-title" xd-qa-type="label" xd-qa-name="Neighborhood Search Define Target Area Description">
                        To get started, define an area in order to select neighborhoods
                    </div>
                </div>
                
                {TargetTypes({
                    selected: type.value,
                    onSelect: (type1) => type.change(() => type1),
                })}

                {selectTargetForm && (
                    <div className="box">
                        {selectTargetForm.render({
                            showErrors,
                        })}
                    </div>
                )}
            </div>
        ),
    }),
);

const TargetTypes = ({selected, onSelect}) => (
    <div className={cx("target-types")}>
        {[
            {
                searchType: "zip",
                label: "By Zip Code",
            },
            {
                searchType: "state",
                label: "By City",
            },
        ]
            .map(({searchType, label}) => (
                <div
                    className="target-type" key={searchType}
                    onClick={() => onSelect(searchType)}
                >
                    {Radio({
                        selected: searchType === selected,
                        xdQaName: "Neighborhood Search "+label,
                    })}
                    <div className="label" xd-qa-type="label" xd-qa-name={"Neighborhood Search "+label}>
                        {label}
                    </div>
                </div>
            ))
        }
    </div>
);




